import { ABSENCES } from '../review/vocabulary';

/**
 * What this screen cannot do, said rather than omitted
 * (docs/DECISIONS.md ZD-112).
 *
 * ZD-035 §2's rule is that an absence has to be a declaration and a bare one is
 * an error, and the report already declares its own limits to a client. A reviewer
 * meeting a workspace with no answer control has no way to tell a deliberate scope
 * from a control they failed to find — so each one is named with its reason, in
 * the reviewer's terms rather than in session ids.
 */
export function Absences(): React.JSX.Element {
  return (
    <section className="absences">
      <h3>What this screen does not do yet</h3>
      <dl>
        {ABSENCES.map((absence) => (
          <div key={absence.what}>
            <dt>{absence.what}</dt>
            <dd>{absence.why}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
